import { Link } from 'react-router-dom';

const columns = [
  {
    title: '快速导航',
    links: [
      { to: '/catalog', label: '漫画大全' },
      { to: '/catalog?c=热血冒险', label: '热血冒险' },
      { to: '/catalog?c=恋爱少女', label: '恋爱少女' },
      { to: '/catalog?c=完结经典', label: '完结经典' },
      { to: '/ranking', label: '排行榜' },
    ],
  },
  {
    title: '站内信息',
    links: [
      { to: '/about', label: '关于我们' },
      { to: '/about', label: '内容原则' },
      { to: '/contact', label: '联系我们' },
      { to: '/contact', label: '反馈建议' },
      { to: '/about', label: '常见问题' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="border-t border-background-200 bg-background-100">
      <div className="mx-auto w-full max-w-7xl px-4 py-10 md:px-6">
        <div className="flex flex-col justify-between gap-8 md:flex-row">
          <div className="max-w-sm">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-book-open-fill text-lg" />
              </span>
              <span className="font-heading text-xl text-primary-700">漫画免费站</span>
            </div>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              漫画免费全集目录聚合站，热门长篇、完结佳作一次收齐。漫画免费资源持续整理，按分类快速找书，追更补番更省心。
            </p>
          </div>
          {columns.map((col) => (
            <div key={col.title}>
              <h4 className="mb-3 font-heading text-base text-foreground-900">{col.title}</h4>
              <ul className="space-y-2">
                {col.links.map((link) => (
                  <li key={link.label}>
                    <Link to={link.to} className="text-sm text-foreground-600 transition-colors hover:text-primary-600">
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-8 flex flex-col items-center justify-between gap-3 border-t border-background-200 pt-6 sm:flex-row">
          <p className="text-xs text-foreground-500">© 2026 漫画免费站 · 免费漫画全集聚合阅读平台</p>
          <div className="flex items-center gap-4 text-xs text-foreground-500">
            <span className="flex items-center gap-1"><i className="ri-time-line" /> 每日更新</span>
            <span className="flex items-center gap-1"><i className="ri-shield-check-line" /> 精选内容</span>
            <span className="flex items-center gap-1"><i className="ri-heart-3-line" /> 免费阅读</span>
          </div>
        </div>
      </div>
    </footer>
  );
}